import "../../styles/ViewAllPage.scss";
import { ItemModel } from "../../../../../../infrastructure/model/ProductItemModel";
import ProductCard from "./ProductCard";
import { useEffect } from "react";

interface ViewAllPageProps {
  items: ItemModel[];
  title: string;
  onAdd: (item: ItemModel) => void;
  icon?: string;
  onGoBack: () => void;
}

function ViewAllPage(props: ViewAllPageProps) {
  const { items, title, icon, onAdd, onGoBack } = props;

  useEffect(() => {
    document.getElementById("content_scrollable_app_element")?.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="view-all-page">
      {/* Header */}
      <div className="view-all-header">
        <button className="back-btn" onClick={() => onGoBack()}>
          ←
        </button>
        <h1>
          {icon && <span className="icon">{icon}</span>}
          {title}
        </h1>
      </div>

      {/* Product list */}
      <div className="view-all-grid">
        {items.map((item) => (
          <ProductCard key={item.id} item={item} onAdd={onAdd} />
        ))}
      </div>
    </div>
  );
}

export default ViewAllPage;
